import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let ProfileMenuComp;

class Profile_menu extends Route {
    render() {
       return { outlet: '#zcatcomponent', component: ProfileMenuComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/profile-menu-comp" */
            "../../../components/javascript/zcat-components/profile-menu-comp"
        ).then(function(res) {
            ProfileMenuComp = res.ProfileMenuComp;
        }));

        
;
    }
}

export {Profile_menu};

